// Sugalarm — meal-photo File handoff (cycle 202).
//
// The Android-tablet kiosk Carbs CTA opens the photo chooser from the tap
// gesture (a hidden <input type="file">.click()), then routes to
// /log/photo entering directly at the `preview` phase. A picked File can't
// ride React Router history state (it isn't structured-clone-serializable
// the way the router wants, and we deliberately avoid stuffing a blob
// through navigation), so this single-slot module holder carries it across
// the nav. PhotoMealScreen peeks it in its state initializer (pure — safe
// under StrictMode double-invoke) and clears it once in a mount effect.
//
// Single consumer, single producer, same tick — no queue needed.

let pendingPhotoFile: File | null = null;

export function setPendingPhotoFile(file: File): void {
  pendingPhotoFile = file;
}

/** Read the pending File without clearing it (safe to call repeatedly,
 *  e.g. from a StrictMode-double-invoked state initializer). */
export function peekPendingPhotoFile(): File | null {
  return pendingPhotoFile;
}

/** Clear the slot (called once from PhotoMealScreen's mount effect after
 *  the File has been adopted). */
export function clearPendingPhotoFile(): void {
  pendingPhotoFile = null;
}
